import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

var specs = { // gbo / bi-tw / bi-ew
                
    '101' : {'5100': [77,273,282], '5400': [84,297,306], '5700': [87,308,318], '6000': [0,0,0]},
    '201' : {'5100': [100,345,356], '5400': [109,375,386], '5700': [114,390,401], '6000': [0,0,0]},
    '301' : {'5100': [108,371,384], '5400': [118,404,416], '5700': [123,420,432], '6000': [0,0,0]},
    '200' : {'5100': [80,279,289], '5400': [87,304,313], '5700': [90,316,325], '6000': [0,0,0]},
    '300' : {'5100': [85,297,307], '5400': [92,323,333], '5700': [96,336,346], '6000': [0,0,0]},
    '202' : {'5100': [119,404,418], '5400': [130,440,453], '5700': [135,457,471], '6000': [0,0,0]},
    '302' : {'5100': [127,430,444], '5400': [139,467,482], '5700': [145,486,500], '6000': [0,0,0]},
    '101llb' : {'5100': [0,0,0], '5400': [0,0,0], '5700': [0,0,0], '6000': [101, 357, 366]},

}
var prices = {
    types: {
        '101' : {'5100': [105650, 118850], '5400': [109450, 122650], '5700': [111450, 124650], '6000': [119450, 134650]},
        '201' : {'5100': [117800, 132500], '5400': [119800, 134500], '5700': [121800, 136500], '6000': [0,0]},
        '301' : {'5100': [120800, 136500], '5400': [122800, 138500], '5700': [124800, 140500], '6000': [0,0]},
        '200' : {'5100': [113950, 128250], '5400': [115950, 130250], '5700': [117950, 132250], '6000': [0,0]},
        '300' : {'5100': [115500, 130800], '5400': [118500, 133800], '5700': [121000, 136300], '6000': [0,0]},
        '202' : {'5100': [128200, 147000], '5400': [130700, 149500], '5700': [132700, 151500], '6000': [0,0]},
        '302' : {'5100': [131450, 151250], '5400': [133700, 153500], '5700': [136200, 156000], '6000': [0,0]},
        '101llb' : {'5100': [0, 0], '5400': [0, 0], '5700': [0, 0], '6000': [119450, 134650]},
    },
    options: {
        // aanbouw12: 12500,
        aanbouw: 1,
        // aanbouw24: 17500,
        dakkapel: 1,
        tuitgevel: 1,
        slaapzolder: 1,
        verspringing: 1,
        sanitair: {
            comfort: 0,
            luxe: 1,
            excellent: 2
        },
        tweedetoilet: 1,
        douchewand: {
            geen: 0,
            douchewandGlas: 1,
            douchewandGlasDeur: 2,
        },
        bad: 1,
        wandafwerking: {
            behangklaar: 0,
            sausklaar: 1,
            scanbehang: 2
        },
        wittedakplaten: 1,
        nom: 1,
        nom3laagstoeslag: 1,
        extraslaapkamerllb: 1,
        heipalen: {
            '10': 0,
            '15': 600,
            '20': 1200,
        },
    }
}

function initialConfiguratorState() {
    return {
        verschijningsvorm: '2 lagen met kap',
        diepte: '8,8 meter',
        architectuur: 'Jaren 30',
        typerechts: '2 lagen',
        typelinks: '2 lagen',
        opties : {
            sanitair : 'Comfort',
            tweedetoilet : 'Nee',
            douchewand : 'Geen',
            bad : 'Nee',
            wandafwerking : 'Behangklaar',
            wittedakplaten : 'Nee',
            nom : 'Nee',
            heipalen: '10 meter',
            startjaar : '2022',
            keuken: 'Geen'
        },
        // types: ["101", "200", "301", "302"],
        display: {
            beukmaat51: 1,
            beukmaat54: 1,
            beukmaat57: 1,
            beukmaat60: 0,
            dakkapel: 1,
            diepte88: 1,
            diepte94: 1,
            diepte103: 0,
            aanbouw : 1,
            tuitgevel: 1,
            slaapzolder: 1,
            wittedakplaten: 1,
            heefttweedeverdieping: 1,
            slaapkamerllb: 0,
        },
        aantallen : {
            beukmaat51 : 0,
            beukmaat54 : 0,
            beukmaat57 : 0,
            beukmaat60 : 0,
            dakkapel : 0,
            aanbouw : 0,
            tuitgevel : 0,
            slaapzolder : 0,
            drielagen: 0,
            tweelagen: 0,
            overgang: 0,
            llb1slaapkamer: 0,
            llb2slaapkamer: 0,
        },
    };
}



export const store = new Vuex.Store({
    state: {
        uuid: '',
        configurators: {
            1 : initialConfiguratorState(),
            2 : initialConfiguratorState(),
            3 : initialConfiguratorState(),
            4 : initialConfiguratorState(),
            5 : initialConfiguratorState(),
            6 : initialConfiguratorState(),
            7 : initialConfiguratorState(),
            8 : initialConfiguratorState(),

        }
    },
    getters: {
        fullConfig: state => {
            return state.configurators;
        },
        blockById: state => (id) => {
            return state.configurators[id];
        },
        total: (state, getters)=> (varname) => {
            var sum = 0;
            for( var i in [...Array(8).keys()] ) {
                sum += getters[varname](parseInt(i)+1);
                
            }
            return sum;
        },
        gbo: (state, getters) => (id) => {
            var base = specs[getters.blockType(id)];
            let localsum = 0;
            if (parseInt(getters.blockById(id).aantallen.beukmaat51)) {localsum += parseInt(getters.blockById(id).aantallen.beukmaat51) * parseInt(getters.blockById(id).display.beukmaat51) * base['5100'][0]};
            if (parseInt(getters.blockById(id).aantallen.beukmaat54)) {localsum += parseInt(getters.blockById(id).aantallen.beukmaat54) * parseInt(getters.blockById(id).display.beukmaat54) * base['5400'][0]};
            if (parseInt(getters.blockById(id).aantallen.beukmaat57)) {localsum += parseInt(getters.blockById(id).aantallen.beukmaat57) * parseInt(getters.blockById(id).display.beukmaat57) * base['5700'][0]};
            if (parseInt(getters.blockById(id).aantallen.beukmaat60)) {localsum += parseInt(getters.blockById(id).aantallen.beukmaat60) * parseInt(getters.blockById(id).display.beukmaat60) * base['6000'][0]};
            return localsum;
        },
        bi: (state, getters) => (id) => {
            var base = specs[getters.blockType(id)];
            let localsum = 0;
            if (parseInt(getters.blockById(id).aantallen.beukmaat51)) {localsum += parseInt(getters.blockById(id).aantallen.beukmaat51) * parseInt(getters.blockById(id).display.beukmaat51) * base['5100'][1]};
            if (parseInt(getters.blockById(id).aantallen.beukmaat54)) {localsum += parseInt(getters.blockById(id).aantallen.beukmaat54) * parseInt(getters.blockById(id).display.beukmaat54) * base['5400'][1]};
            if (parseInt(getters.blockById(id).aantallen.beukmaat57)) {localsum += parseInt(getters.blockById(id).aantallen.beukmaat57) * parseInt(getters.blockById(id).display.beukmaat57) * base['5700'][1]};
            if (parseInt(getters.blockById(id).aantallen.beukmaat60)) {localsum += parseInt(getters.blockById(id).aantallen.beukmaat60) * parseInt(getters.blockById(id).display.beukmaat60) * base['6000'][1]};
            return localsum;
        },
        numberOfHouses: (state, getters) => (id) => {
            return parseInt(getters.blockById(id).aantallen.beukmaat51) * parseInt(getters.blockById(id).display.beukmaat51) + 
            parseInt(getters.blockById(id).aantallen.beukmaat54) * parseInt(getters.blockById(id).display.beukmaat54) +
            parseInt(getters.blockById(id).aantallen.beukmaat57) * parseInt(getters.blockById(id).display.beukmaat57) +
            parseInt(getters.blockById(id).aantallen.beukmaat60) * parseInt(getters.blockById(id).display.beukmaat60);
        },
        totalLength: (state, getters) => (id) => {
            return getters.numberOfHouses(id) ? (parseInt(getters.blockById(id).aantallen.beukmaat51) * 5.058 + 
                    parseInt(getters.blockById(id).aantallen.beukmaat54) * 5.498 + 
                    parseInt(getters.blockById(id).aantallen.beukmaat57) * 5.717 + 
                    parseInt(getters.blockById(id).aantallen.beukmaat60) * 6.158 +
                    0.6).toFixed(1).replace('.',',') : 0
        },
        average: (state, getters) => (id) => {
            return getters.numberOfHouses(id)? Math.round(getters.priceOfBlock(id) / getters.numberOfHouses(id)) : 0;
        },
        blockType: state => (id) => {
            switch(state.configurators[id].verschijningsvorm) {
                case '1 laag met kap (levensloopbestendig)':
                    return '101llb'
                case '1 laag met kap':
                    return '101';
                case '2 lagen met kap':
                    switch(state.configurators[id].diepte) {
                        case '8,8 meter': return '201';
                        case '9,4 meter': return '301';
                    }
                case '2 lagen met plat dak':
                    switch(state.configurators[id].diepte) {
                        case '8,8 meter': return '200';
                        case '9,4 meter': return '300';
                    }
                case '3 lagen met plat dak':
                    switch(state.configurators[id].diepte) {
                        case '8,8 meter': return '202';
                        case '9,4 meter': return '302';
                    }
                case '2 en 3 lagen met plat dak gecombineerd':
                    switch(state.configurators[id].diepte) {
                        case '8,8 meter': return '202';
                        case '9,4 meter': return '302';
                    }
            }
        },
        pdfUrls: (state, getters) => (id) => {
            var urls = {};
            let blocktype = getters.blockType(id);
            if (state.configurators[id].aantallen.beukmaat51 * state.configurators[id].display.beukmaat51) {
                urls['5.1m'] = "static/plattegronden/3.0_" + blocktype + "-5058.pdf";
            }
            if (state.configurators[id].aantallen.beukmaat54 * state.configurators[id].display.beukmaat54) {
                urls['5.4m'] = "static/plattegronden/3.0_" + blocktype + "-5498.pdf";
            }
            if (state.configurators[id].aantallen.beukmaat57 * state.configurators[id].display.beukmaat57) {
                urls['5.7m'] = "static/plattegronden/3.0_" + blocktype + "-5718.pdf";
            }
            if (state.configurators[id].aantallen.beukmaat60 * state.configurators[id].display.beukmaat60) {
                urls['6.2m'] = "static/plattegronden/3.0_" + blocktype + "-6158.pdf";
            }
            console.log(urls);
            return urls;
        },
        priceOfBlock: (state, getters) => (id) => {
            // return state.configurators[id];
            // return 14;
            let localblock = getters.blockById(id);
            if (localblock.verschijningsvorm === '2 en 3 lagen met plat dak gecombineerd') {
                var cascoprice = 0;
                if (this.blockType === '202') { /* 8,8 meter */
                cascoprice += parseInt(localblock.aantallen.drielagen) * prices.types['202']['5400'][0];
                cascoprice += parseInt(localblock.aantallen.tweelagen) * prices.types['200']['5400'][0];
                }
                else { /* 9,4 meter */
                cascoprice += parseInt(localblock.aantallen.drielagen) * prices.types['302']['5400'][0];
                cascoprice += parseInt(localblock.aantallen.tweelagen) * prices.types['300']['5400'][0];
                }
                ;
            }
            else {
                var baseprice = prices.types[getters.blockType(id)];
                var cascoprice = 0;
                if (parseInt(localblock.display.beukmaat51)) {cascoprice += parseInt(localblock.aantallen.beukmaat51) * parseInt(localblock.display.beukmaat51) * baseprice['5100'][0]};
                if (parseInt(localblock.display.beukmaat54)) {cascoprice += parseInt(localblock.aantallen.beukmaat54) * parseInt(localblock.display.beukmaat54) * baseprice['5400'][0]};
                if (parseInt(localblock.display.beukmaat57)) {cascoprice += parseInt(localblock.aantallen.beukmaat57) * parseInt(localblock.display.beukmaat57) * baseprice['5700'][0]};
                if (parseInt(localblock.display.beukmaat60)) {cascoprice += parseInt(localblock.aantallen.beukmaat60) * parseInt(localblock.display.beukmaat60) * baseprice['6000'][0]};
                // console.log(cascoprice);
            }
            var options = parseInt(localblock.aantallen.aanbouw) * parseInt(prices.options.aanbouw) * parseInt(localblock.display.aanbouw) + 
                            parseInt(localblock.aantallen.dakkapel) * parseInt(prices.options.dakkapel) * parseInt(localblock.display.dakkapel) + 
                            parseInt(localblock.aantallen.slaapzolder) * parseInt(prices.options.slaapzolder) * parseInt(localblock.display.slaapzolder) + 
                            parseInt(localblock.aantallen.tuitgevel) * parseInt(prices.options.tuitgevel) * parseInt(localblock.display.tuitgevel) + 
                            parseInt(getters.numberOfHouses(id)) * parseInt(prices.options.bad) * (localblock.opties.bad == 'Ja' ? 1 : 0) + 
                            parseInt(getters.numberOfHouses(id)) * parseInt(prices.options.tweedetoilet) * (localblock.opties.tweedetoilet == 'Ja' ? 1 : 0) + 
                            parseInt(getters.numberOfHouses(id)) * parseInt(prices.options.wittedakplaten) * (localblock.opties.wittedakplaten == 'Ja' ? 1 : 0) * parseInt(localblock.display.wittedakplaten) +
                            parseInt(localblock.aantallen.llb1slaapkamer) * parseInt(prices.options.extraslaapkamerllb) * parseInt(localblock.display.slaapkamerllb) +
                            parseInt(localblock.aantallen.llb2slaapkamer) * parseInt(prices.options.extraslaapkamerllb) * 2 * parseInt(localblock.display.slaapkamerllb) +
                            parseInt(getters.numberOfHouses(id)) * parseInt(prices.options.nom) * (localblock.opties.nom == 'Ja' ? 1 : 0);
            switch(localblock.opties.sanitair) {
                case 'Luxe' : options += (parseInt(getters.numberOfHouses(id)) * prices.options.sanitair.luxe); break;
                case 'Excellent' : options += (parseInt(getters.numberOfHouses(id)) * prices.options.sanitair.excellent); break;
            }
            switch(localblock.opties.douchewand) {
                case 'Glazen douchewand' : options += (parseInt(getters.numberOfHouses(id)) * prices.options.douchewand.douchewandGlas); break;
                case 'Glazen douchewand + deur' : options += (parseInt(getters.numberOfHouses(id)) * prices.options.douchewand.douchewandGlasDeur); break;
            }
            switch(localblock.opties.keuken) {
                case 'Ter waarde van € 2000' : options += (parseInt(getters.numberOfHouses(id)) * 2000); break;
                case 'Ter waarde van € 4000' : options += (parseInt(getters.numberOfHouses(id)) * 4000); break;
                case 'Ter waarde van € 6000' : options += (parseInt(getters.numberOfHouses(id)) * 6000); break;
            }
            switch(localblock.opties.wandafwerking) {
                case 'Sausklaar' : options += (parseInt(getters.numberOfHouses(id)) * prices.options.wandafwerking.sausklaar); break;
                case 'Scanbehang wit gesausd' : options += (parseInt(getters.numberOfHouses(id)) * prices.options.wandafwerking.scanbehang); break;
            }
            switch(localblock.opties.heipalen) {
                case 'Prefab 15 meter' : options += (parseInt(getters.numberOfHouses(id)) * prices.options.heipalen['15']); break;
                case 'Prefab 20 meter' : options += (parseInt(getters.numberOfHouses(id)) * prices.options.heipalen['20']); break;
                // case 'Mortel schroef 10 meter' : options += (parseInt(getters.numberOfHouses(id)) * prices.options.heipalen['20']); break;
                case 'Mortel schroef 15 meter' : options += (parseInt(getters.numberOfHouses(id)) * prices.options.heipalen['15']); break;
                case 'Mortel schroef 20 meter' : options += (parseInt(getters.numberOfHouses(id)) * prices.options.heipalen['20']); break;
            }
            switch(localblock.architectuurkosten) {
                case 'Ter waarde van € 4000' : options += parseInt(getters.numberOfHouses(id)) * 1500; break;
                case 'Ter waarde van € 5500' : options += parseInt(getters.numberOfHouses(id)) * 3000; break;
            }

            var total = cascoprice + options;
            // console.log(options);
            // if (localblock.opties.startjaar == '2021') {
            //     return Math.round(total / 1.03 * 1.015);
            // }
            
            // Compensate for staffel
            var totalnumberofhouses = parseInt(getters.total('numberOfHouses'));
            var localnumberofhouses = parseInt(getters.numberOfHouses(id));
            if (totalnumberofhouses <= 14) { total += localnumberofhouses * 3000 } else
            if (totalnumberofhouses <= 19) { total += localnumberofhouses * 2500 } else
            if (totalnumberofhouses <= 29) { total += localnumberofhouses * 0 } else
            if (totalnumberofhouses <= 49) { total -= localnumberofhouses * 2000 } else
            if (totalnumberofhouses >= 50) { total -= localnumberofhouses * 3000 }

            // TODO Compensate for postcode
            var zipcodes = {10:4000, 11:4000, 12:4000, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:2000,
                            20:2000, 21:2000, 22:4000, 23:4000, 24:4000, 25:4000, 26:4000, 27:4000, 28:4000, 29:4000,
                            30:4000, 31:4000, 32:4000, 33:4000, 34:2000, 35:2000, 36:2000, 37:2000, 38:2000, 39:2000,
                            40:2000, 41:2000, 42:2000, 43:2000, 44:2000, 45:2000, 46:2000, 47:2000, 48:2000, 49:2000,
                            50:2000, 51:2000, 52:2000, 53:2000, 54:2000, 55:2000, 56:2000, 57:2000, 58:2000, 59:2000,
                            60:2000, 61:2000, 62:2000, 63:2000, 64:2000, 65:2000, 66:2000, 67:2000, 68:2000, 69:2000,
                            70:2000, 71:2000, 72:2000, 73:2000, 74:0, 75:0, 76:0, 77:-1000, 78:-1000, 79:-1000,
                            80: 0, 81:0, 82:0, 83:-1000, 84:-1000, 85:-1000, 86:-1000, 87:-1000, 88:-1000, 89:-1000,
                            90:-1000, 91:-1000, 92:-1000, 93:-1000, 94:-1000, 95:-1000, 96:-1000, 97:-1000, 98:-1000, 99:-1000
            }
            total += localnumberofhouses * zipcodes[state.zipcode]

            return total;
        },
        typeOfBlock: state => (id) => {
            switch(state.configurators[id].verschijningsvorm) {
                case '1 laag met kap (levensloopbestendig)':
                    return '101llb'
                case '1 laag met kap':
                    return '101';
                case '2 lagen met kap':
                    switch(state.configurators[id].diepte) {
                        case '8,8 meter': return '201';
                        case '9,4 meter': return '301';
                    }
                case '2 lagen met plat dak':
                    switch(state.configurators[id].diepte) {
                        case '8,8 meter': return '200';
                        case '9,4 meter': return '300';
                    }
                case '3 lagen met plat dak':
                    switch(state.configurators[id].diepte) {
                        case '8,8 meter': return '202';
                        case '9,4 meter': return '302';
                    }
                case '2 en 3 lagen met plat dak gecombineerd':
                    switch(state.configurators[id].diepte) {
                        case '8,8 meter': return '202';
                        case '9,4 meter': return '302';
                    }
            }
            console.log("Hier hoor ik niet te komen!");
            return '201';
        },
    },
    mutations: {
        updateConfiguration: (state, payload) => {
            state.configurators[payload.id] = payload.data;

        }
    },
    actions: {
        updateConfiguration: (context, payload) => {
            context.commit('updateConfiguration', payload)
        }
        
    }
});


// WEBPACK FOOTER //
// ./src/store/store.js